import React, { Component, createContext, useContext } from 'react';
import axios from 'axios';

const ConnectContext = createContext();

class ConnectProvider extends Component {
    state = {
        partners: [],
        elos: [],
        partner: {},
        filesByPartner: [],
        searchParam: '',
        loading: true,
        loadingAllELO: true,
        loadingPartner: true,
        loadingELO: true,
        loadingPictures: true,
        elosByPartner: [],
        contactUrl: '',
        filteredUrls: [],
        checkIndex: 0,
        isPartnerSearch: false
    }

    // reset context on page load
    resetContext = async () => {
        window.scrollTo(0, 0);
        this.setState({
            partners: [],
            elos: [],
            partner: {},
            filesByPartner: [],
            searchParam: '',
            loading: true,
            loadingAllELO: true,
            loadingPartner: true,
            loadingELO: true,
            loadingPictures: true,
            elosByPartner: [],
            contactUrl: '',
            filteredUrls: [],
            checkIndex: 0
        });
    }

    // fetch all partners from data provider
    fetchAllPartners = async () => {
        try {
            const response = await axios.get(`/api/data`);
            this.setState({
                partners: response.data,
                loading: false
            });
        } catch (error) {
            console.error('Error fetching data from the server:', error);
            this.setState({
                loading: false
            });
        }
    }

    // fetch all elos from data provider
    fetchAllELOs = async () => {
        try {
            const response = await axios.get(`/api/elos`);
            this.setState({
                elos: response.data,
                loadingAllELO: false
            });
        } catch (error) {
            console.error('Error fetching elos from the server:', error);
            this.setState({
                loadingAllELO: false
            });
        }
    }

    // fetch partner by name from data provider
    fetchPartner = async (partnerName) => {
        try {
            const response = await axios.get(`/api/partner?Name=${partnerName}`);
            this.setState({
                partner: response.data,
                loadingPartner: false
            });
        } catch (error) {
            console.error('Error fetching data from the server:', error);
            this.setState({
                loadingPartner: false
            });
        }
    }

    // fetch ELOs by partner name
    fetchELOsByPartner = async (partnerName) => {
        window.scrollTo(0, 0)
        try {
            const response = await axios.get(`/api/elos-by-partner?Name=${partnerName}`);
            this.setState({
                elosByPartner: response.data,
                loadingELO: false
            });
        } catch (error) {
            console.error('Error fetching data from the server:', error);
            this.setState({
                loadingELO: false
            });
        }
    }

    // set the search filter
    setSearchParam = async (input) => {
        this.setState({ searchParam: input });
    }

    // Fetch files for a partner based on partnerName
    fetchFilesByPartner = async (partnerName) => {
        try {
            // Fetch partner details
            const partnerResponse = await axios.get(`/api/partner?Name=${partnerName}`);
            const partnerData = partnerResponse.data;
            const folderId = partnerData["Folder ID"];
            const response = await axios.get(`/api/files-in-folder?folderId=${folderId}`);
            const imageFiles = response.data.filter(file =>
                file.mimeType && file.mimeType.startsWith('image/')
            );
            const contactImage = imageFiles.find(file => file.name.toLowerCase().includes('contact'));
            const filteredFiles = imageFiles.filter(file => file !== contactImage);
            const contactUrl = contactImage?.id
                ? `/api/drive-image/${contactImage.id}`
                : null;
            const filteredUrls = filteredFiles.map(file =>
                `/api/drive-image/${file.id}`
            );
            this.setState({
                contactUrl: contactUrl,
                filteredUrls: filteredUrls,
                checkIndex: 0,
                loadingPictures: false
            });
            return;
        } catch (error) {
            console.error('Error fetching files in folder:', error);
            this.setState({
                loadingPictures: false
            });
        }
    }

        // Fetch files for a partner based on partnerName
        fetchContactUrl = async (partnerName) => {
            try {
                // Fetch partner details
                const partnerResponse = await axios.get(`/api/partner?Name=${partnerName}`);
                const partnerData = partnerResponse.data;
                const folderId = partnerData["Folder ID"];
                const response = await axios.get(`/api/files-in-folder?folderId=${folderId}`);
                const imageFiles = response.data.filter(file =>
                    file.mimeType && file.mimeType.startsWith('image/')
                );
                const contactImage = imageFiles.find(file => file.name.toLowerCase().includes('contact'));
                const contactUrl = contactImage?.id
                    ? `/api/drive-image/${contactImage.id}`
                    : null;
                return contactUrl;
            } catch (error) {
                console.error('Error fetching files in folder:', error);
            }
        }

    // set the search filter
    setCheckIndex = async (input) => {
        this.setState({ checkIndex: input });
    }

    // set partner search view toggle
    setIsPartnerSearch = (value) => {
        this.setState({ isPartnerSearch: value });
    }

    render() {
        return (
            <ConnectContext.Provider
                value={{
                    ...this.state,
                    fetchAllPartners: this.fetchAllPartners,
                    fetchPartner: this.fetchPartner,
                    resetContext: this.resetContext,
                    setSearchParam: this.setSearchParam,
                    setCheckIndex: this.setCheckIndex,
                    fetchELOsByPartner: this.fetchELOsByPartner,
                    fetchFilesByPartner: this.fetchFilesByPartner,
                    fetchContactUrl: this.fetchContactUrl,
                    fetchAllELOs: this.fetchAllELOs,
                    setIsPartnerSearch: this.setIsPartnerSearch,
                }}
            >
                {this.props.children}
            </ConnectContext.Provider>
        );
    }
}

export { ConnectContext };

export default ConnectProvider;

export const useConnectContext = () => useContext(ConnectContext);
